import { trackSitePage } from "./src/data/siteAnalytics";
import type { GatsbyBrowser } from "gatsby";
import { AppProviders } from "./src/components/AppProviders";
import { FOOTBALL_RESET_EVENT } from "./src/components/footballShot";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
  <AppProviders>{element}</AppProviders>
);

let pendingFrame: number | undefined;
let pageFade: Animation | undefined;

export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] = () => {
  // Gatsby restores its saved positions. Native restoration can otherwise write
  // the destination position into the page being left during a history change.
  window.history.scrollRestoration = "manual";
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location, prevLocation }) => {
  trackSitePage();
  // Initial loads and changes within the same page retain their native behavior.
  if (!prevLocation || location.pathname === prevLocation.pathname) return;
  if (pendingFrame !== undefined) cancelAnimationFrame(pendingFrame);
  pageFade?.cancel();
  window.dispatchEvent(new Event(FOOTBALL_RESET_EVENT));

  pendingFrame = requestAnimationFrame(() => {
    // Gatsby's wrapper-focus effect can run after the first frame. Finish that
    // routing step before focusing the actual destination heading.
    pendingFrame = requestAnimationFrame(() => {
      pendingFrame = undefined;
      const main = document.querySelector("main");
      if (!main) return;

      // Do not pull focus away from a destination anchor or change history scroll restoration.
      if (!location.hash) {
        const heading = main.querySelector("h1");
        if (heading) {
          heading.tabIndex = -1;
          heading.focus({ preventScroll: true });
        }
      }

      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches && main.animate) {
        pageFade = main.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 150,
          easing: "ease-out",
        });
      }
    });
  });
};
